import { compileMarkdownDocument } from "./markdown";
import { estimateProfileReadingStats } from "./reading-time";
import type { CompiledMarkdownDocument, ProfileContent, ProfileRenderModel } from "./types";

export function buildProfileRenderModel(
  profile: ProfileContent,
  compiledMarkdown: CompiledMarkdownDocument = compileMarkdownDocument(profile.bodyMarkdown)
): ProfileRenderModel {
  const compiled = compiledMarkdown;
  const publicProfile = compiled.canonicalPublicMarkdown === profile.bodyMarkdown
    ? profile
    : { ...profile, bodyMarkdown: compiled.canonicalPublicMarkdown };
  return {
    profile: publicProfile,
    sections: compiled.sections,
    reading: estimateProfileReadingStats(publicProfile, compiled.visibleText)
  };
}
